/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import styled from 'styled-components';

const fontColor = (props) => {
  switch (props.theme) {
    case 'brand': {
      return 'white';
    }
    case 'destructive': {
      return 'white';
    }
    case 'destructive-inverse': {
      return '#c23934';
    }
    case 'neutral':
    default: {
      return '#0070D2';
    }
  }
};

const bgColor = (props) => {
  switch (props.theme) {
    case 'brand': {
      return '#0070d2';
    }
    case 'destructive': {
      return '#c23934';
    }
    case 'destructive-inverse': {
      return 'white';
    }
    case 'neutral':
    default: {
      return 'white';
    }
  }
};

const borderColor = (props) => {
  switch (props.theme) {
    case 'brand': {
      return '#0070d2';
    }
    case 'destructive': {
      return '#c23934';
    }
    case 'destructive-inverse': {
      return '#DDDBDA';
    }
    case 'neutral':
    default: {
      return '#DDDBDA';
    }
  }
};

const focusedBGColor = (props) => {
  switch (props.theme) {
    case 'brand': {
      return '#005fb2';
    }
    case 'destructive': {
      return '#870500';
    }
    case 'destructive-inverse': {
      return '#F4F6F9';
    }
    case 'neutral':
    default: {
      return '#F4F6F9';
    }
  }
};

const focusedBorderColor = (props) => {
  switch (props.theme) {
    case 'brand': {
      return '#005fb2';
    }
    case 'destructive': {
      return '#870500';
    }
    case 'destructive-inverse': {
      return '#DDDBDA';
    }
    case 'neutral':
    default: {
      return '#DDDBDA';
    }
  }
};

const disabledFontColor = (props) => {
  switch (props.theme) {
    case 'brand': {
      return '';
    }
    case 'destructive': {
      return '';
    }
    case 'destructive-inverse': {
      return '#dddbda';
    }
    case 'neutral':
    default: {
      return '#dddbda';
    }
  }
};

const disabledBGColor = (props) => {
  switch (props.theme) {
    case 'brand': {
      return '#e0e5ee';
    }
    case 'destructive': {
      return '#e0e5ee';
    }
    case 'destructive-inverse': {
      return 'white';
    }
    case 'neutral':
    default: {
      return 'white';
    }
  }
};

const disabledBorderColor = (props) => {
  switch (props.theme) {
    case 'brand': {
      return 'transparent';
    }
    case 'destructive': {
      return 'transparent';
    }
    case 'destructive-inverse': {
      return 'white';
    }
    case 'neutral':
    default: {
      return 'white';
    }
  }
};

const Button = styled.button`
  color: ${fontColor};

  display: inline-block;
  padding: 0;
  background-clip: border-box;
  border-radius: 0.25rem;
  line-height: 1.875rem;
  text-decoration: none;
  white-space: normal;
  user-select: none;
  overflow: visible;

  border: 1px solid #dddbda;
  background-color: ${bgColor};
  border-color: ${borderColor};

  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;
  vertical-align: middle;
  transition: border 0.15s linear;


  &:focus {
    outline: 0;
    box-shadow: 0 0 3px #0070D2;
  }

  &:active {
    background-color: ${focusedBGColor};
    border-color: ${focusedBorderColor};
  }

  &:active, &:focus, &:hover {
    text-decoration: none;
  }

  &[disabled] {
    color: ${disabledFontColor};
    background-color: ${disabledBGColor};
    border-color: ${disabledBorderColor};
  }
`;

export default Button;
